import { render, staticRenderFns } from "./TextConsentConfirmationModal.vue?vue&type=template&id=3a42ead6&scoped=true"
import script from "./TextConsentConfirmationModal.vue?vue&type=script&lang=js"
export * from "./TextConsentConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./TextConsentConfirmationModal.vue?vue&type=style&index=0&id=3a42ead6&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a42ead6",
  null
  
)

export default component.exports